import { handleActions } from "redux-actions";
import {
    BRAND_SHIPPING_CARRIER_COMPLETE,
    BRAND_SHIPPING_CARRIER_REQUEST,
    SHIPPING_ACCOUNT_CARRIER_CREATE,
    SHIPPING_ACCOUNT_CARRIER_CREATE_COMPLETE,
    SHIPPING_ACCOUNT_CARRIER_DELETE,
    SHIPPING_ACCOUNT_CARRIER_DELETE_COMPLETE,
    SHIPPING_ACCOUNT_CARRIER_UPDATE,
    SHIPPING_ACCOUNT_CARRIER_UPDATE_COMPLETE,
    SHIPPING_ACCOUNT_CARRIERS_REQUEST,
    SHIPPING_ACCOUNT_CARRIERS_REQUEST_COMPLETE,
    SHIPPING_ACCOUNT_CARRIERS_RESET,
} from "constants/action-types";

interface IState {
    error?: boolean;
    errorObject: any;
    isFetching: boolean;
    isDeleting: boolean;
    isUpdating: boolean;
    results: string[];
    data: any[] | null;
}

const initialState: IState = {
    error: undefined,
    errorObject: undefined,
    isFetching: false,
    isDeleting: false,
    isUpdating: false,
    results: [],
    data: null,
};

export const shippingAccountCarriers = handleActions(
    {
        [BRAND_SHIPPING_CARRIER_REQUEST]: (state: IState): IState => {
            return {
                ...state,
                isFetching: true,
                errorObject: undefined,
            };
        },
        [SHIPPING_ACCOUNT_CARRIERS_RESET]: (state: IState): IState => {
            return {
                ...state,
                results: [],
            };
        },
        [SHIPPING_ACCOUNT_CARRIERS_REQUEST]: (state: IState): IState => {
            return {
                ...state,
                isFetching: true,
                errorObject: undefined,
            };
        },
        [SHIPPING_ACCOUNT_CARRIERS_REQUEST_COMPLETE]: (state: IState): IState => {
            return {
                ...state,
                isFetching: false,
                errorObject: undefined,
            };
        },
        [SHIPPING_ACCOUNT_CARRIER_CREATE]: (state: IState): IState => {
            return {
                ...state,
                isFetching: true,
                errorObject: undefined,
            };
        },
        [SHIPPING_ACCOUNT_CARRIER_DELETE]: (state: IState): IState => {
            return {
                ...state,
                isDeleting: true,
                errorObject: undefined,
            };
        },
        [SHIPPING_ACCOUNT_CARRIER_DELETE_COMPLETE]: (state: IState, { payload, error }: any): IState => {
            if (error) {
                return {
                    ...state,
                    error: true,
                    isDeleting: false,
                };
            }

            return {
                ...state,
                error,
                isDeleting: false,
                results: state.results.length ? state.results.filter((id) => id !== payload) : payload,
            };
        },
        [SHIPPING_ACCOUNT_CARRIER_UPDATE]: (state: IState): IState => {
            return {
                ...state,
                isUpdating: true,
                errorObject: undefined,
            };
        },
        [SHIPPING_ACCOUNT_CARRIER_UPDATE_COMPLETE]: (state: IState, { payload, error }: any): IState => {
            if (error) {
                return {
                    ...state,
                    error: true,
                    isUpdating: false,
                };
            }

            return {
                ...state,
                error,
                isUpdating: false,
                results: payload,
            };
        },
        [SHIPPING_ACCOUNT_CARRIER_CREATE_COMPLETE]: (state: IState, { payload, error, errorObject }: any): IState => {
            if (error) {
                return {
                    ...state,
                    error: true,
                    errorObject,
                    isFetching: false,
                };
            }

            return {
                ...state,
                error,
                isFetching: false,
                errorObject: undefined,
                results: state.results.length ? (state.results.concat(payload) as string[]) : payload,
            };
        },
        [BRAND_SHIPPING_CARRIER_COMPLETE]: (state: IState, { payload, error, errorObject, data }: any): IState => {
            if (error) {
                return {
                    ...state,
                    error: true,
                    errorObject,
                    isFetching: false,
                    data,
                };
            }

            return {
                ...state,
                error,
                isFetching: false,
                errorObject: undefined,
                results: payload,
                data,
            };
        },
    },
    initialState
);
